export default "__VITE_ASSET__BLvYT_Kl__"